import classnames from 'classnames';
import { observer } from 'mobx-react';
import React from 'react';

import { OnChangeHandlerType } from 'shared/types';

import './styles.scss';

type PropsType = {
    items?: {
        id: string | number | null;
        name: number | string;
    }[];
    value?: string | number | null;
    name?: string;
    onChange?: OnChangeHandlerType<any>;
    style?: React.CSSProperties,
    className?: string,
    variant?: 'default' | 'filled';
}

export const UiTabs = observer((
    {
        items = [],
        value = null,
        name = 'tab',
        style,
        className,
        onChange,
        variant = 'default'
    }: PropsType
) => {

    const handleClick = (value: any) => () => {
        onChange && onChange({ value, name });
    };

    if (!items || items.length === 0) {
        return null;
    }

    const isFilled = variant === 'filled';

    return (
        <div
            className={classnames(
                'ui-tabs',
                className,
                { 'ui-tabs--filled': isFilled }
            )}
            style={style}
        >
            <div className='ui-tabs__outer'>
                <div className='ui-tabs__inner'>
                    {items.map(item => (
                        <div
                            key={item.id}
                            className={classnames('ui-tabs__item', {
                                'ui-tabs__item--active': item.id === value,
                                'ui-tabs__item--filled': isFilled,
                            })}
                            onClick={handleClick(item.id)}
                        >
                            {item.name}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
});
